<div class="p-3">
    <div class="grid">
        <div class="col-12">
            <label for="hoursBack">Hours Back</label>
            <p-inputNumber id="hoursBack" [(ngModel)]="hoursBack" [min]="0" [max]="336" [showButtons]="true" buttonLayout="horizontal" inputId="hoursBack" spinnerMode="horizontal" [step]="4"
            decrementButtonClass="p-button-danger" incrementButtonClass="p-button-success" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"></p-inputNumber>
        </div>
        <div class="col-4">
            <label for="multipleSensors">Multiple</label>
            <p-inputSwitch [(ngModel)]="multipleSensors" inputId="multipleSensors" (click)="clearSelection()"></p-inputSwitch>
        </div>
        <div class="col-4">
            <p-button [disabled]="!canOpenGraph()" label="Open" styleClass="p-button-primary" class="flex justify-content-center" (onClick)="openGraph()"></p-button>
        </div>
        <div class="col-4">
            <p-button label="Clear" styleClass="p-button-secondary" class="flex justify-content-center" (onClick)="clearSelection()"></p-button>
        </div>
    </div>
</div>


<p-table [value]="sensors" [loading]="loading">
    <ng-template pTemplate="body" let-sensor>
        <tr (click)="sensorClicked(sensor)" [ngClass]="sensor.checked ? 'bg-blue-200' : ''">
            <td>
                <div class="grid formgrid">
                    <div class="col pb-0">
                        <div class="grid text-sm">
                            <div class="col-5 font-bold">
                                <div class="flex">
                                    <i *ngIf="sensor.isStage1Alarming || sensor.isStage2Alarming" class="pi pi-exclamation-triangle text-red-600 pr-1"></i>
                                    {{sensor.sensorName}}
                                </div>
                            </div>
                            <div class="col-7 text-right text-xs">
                                {{sensor.lastReading.dateRead | date: "EEE, MM/dd/yy hh:mm a"}}
                            </div>
                            <div class="col-8">
                                {{sensor.notes}}
                            </div>
                            <div class="col-4 text-right" [ngClass]="getReadingClass(sensor)">
                                {{sensor.lastReading.reading}} {{sensor.unitOfMeasure}}
                            </div>
                            <div class="col-5 col-offset-7 text-right">
                                Range {{sensor.lowerLimit}} to {{sensor.upperLimit}}
                            </div>
                        </div>
                    </div>
                    <div class="col-1">
                        <div class="h-full">
                            <i class="pi pi-chevron-right"></i>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Sensor Graph"  [(visible)]="graphModal" [breakpoints]="{ '960px': '95vw' }" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <div class="grid p-fluid flex flex-wrap">
        <div class="col-12 p-1">
            <p-chart type="line" [data]="chartData" [options]="options" id="sensorChart"></p-chart>
        </div>
        <div class="col-12 p-1">
            <p-button label="Close" styleClass="p-button-secondary" class="flex justify-content-center" (onClick)="graphModal = false"></p-button>
        </div>
    </div>
</p-dialog>